import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { Facility } from './facility.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
}

@Injectable({
  providedIn: 'root',
})
export class FacilityService {
  constructor(private http: HttpClient, private utilService: UtilService) {}

  private apiUrl = environment.apiEndpoint + 'facilities';

  getFilterCriteria() {
    let defaultParams: ExtendedDefaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return defaultParams;
  }

  getFacilities(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            // data: resp.data,
            data: resp['data'],
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getFacility(id: string, params = null): Observable<Facility> {
    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get<Facility>(`${this.apiUrl}/${id}`, {
      params: queryParams,
    });
  }

  // Save / Update
  saveFacility(facilityId: string, facility: Facility, lang = ''): Observable<Facility> {
    const body = {
      facility: facility,
      lang: lang || CONSTANTS.DEFAULT_CONTENT_LANGUAGE,
    };

    if (!facilityId) {
      return this.http.post<Facility>(`${this.apiUrl}`, body);
    } else {
      return this.http.put<Facility>(`${this.apiUrl}/${facilityId}`, body);
    }
  }
}
